import { optionSubcategory_distributionGroups } from './distributionGroupsSubCategory.locstring.json';
import { DistributionGroupsOption } from 'owa-distribution-groups-option';
import { OptionSubCategory } from 'owa-options-core';

let distributionGroupsSubCategory: OptionSubCategory = {
    key: 'distributionGroups',
    titleStringKey: optionSubcategory_distributionGroups,
    options: [DistributionGroupsOption],
    onSelected: () => {
        return Promise.resolve(true);
    },
};

export default distributionGroupsSubCategory;
